(() => {
  if (window.KoppaMobileHero) { window.KoppaMobileHero.scan(); return; }
  const mobile = matchMedia('(max-width: 767px)');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  const isVisible = element => element?.checkVisibility ? element.checkVisibility({ visibilityProperty: true, opacityProperty: true }) : !!element?.getClientRects().length;
  const scrollToForm = panel => {
    const waitlist = panel.querySelector('[data-protocol-waitlist]');
    if (waitlist && window.koppaOpenWaitlist) {
      window.koppaOpenWaitlist({handle:waitlist.dataset.productHandle,name:waitlist.dataset.productName});
      return;
    }
    const target = panel.querySelector('input[type="email"], [data-mobile-plan]:checked, select, input[type="number"], button[type="submit"], [role="status"]');
    (target || panel).scrollIntoView({ block: 'center', behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    target?.focus({ preventScroll: true });
  };
  document.addEventListener('click', event => {
    if (!mobile.matches) return;
    const action = event.target.closest?.('[data-koppa-purchase-focus], [data-protocol-focus]');
    const panel = action?.closest('.pp')?.querySelector('[data-mobile-purchase]');
    if (!panel) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    scrollToForm(panel);
  }, true);
  function mount(panel) {
    if (instances.has(panel)) return;
    const page = panel.closest('.pp');
    const gallery = page.querySelector('[data-ploy-product-gallery]');
    const viewport = gallery.querySelector('.product-gallery__viewport');
    const thumbs = gallery.querySelector('.product-gallery__thumbs');
    const count = gallery.querySelector('[data-ploy-gallery-count]');
    const sticky = panel.querySelector('.koppa-mobile-action');
    const submit = panel.querySelector('.koppa-mobile-order button[type="submit"], [data-protocol-waitlist]');
    const form = submit?.form;
    const cleanup = [];
    const on = (target, type, callback, options) => { target?.addEventListener(type, callback, options); cleanup.push(() => target?.removeEventListener(type, callback, options)); };
    on(panel.querySelector('[data-protocol-waitlist]'), 'click', () => scrollToForm(panel));
    const creamStyleGallery = ['ghk-cu-serum','ghk-cu-balm-stick'].includes(page.dataset.ployProductHandle);
    const zoom = document.createElement('button');
    zoom.type = 'button'; zoom.className = 'koppa-mobile-zoom'; zoom.setAttribute('aria-haspopup', 'dialog');
    const dialog = document.createElement('dialog'); dialog.className = 'koppa-mobile-lightbox'; dialog.setAttribute('aria-label', panel.dataset.zoomLabel);
    const close = document.createElement('button'); close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', panel.dataset.closeLabel);
    const image = document.createElement('img'); image.alt = '';
    dialog.append(image, close); document.body.append(dialog); (creamStyleGallery ? gallery.querySelector('.product-gallery__stage') : gallery).append(zoom); gallery.dataset.mobileGalleryReady = 'true';
    let frame = 0;
    let mainVisible = false;
    const update = () => {
      const active = document.activeElement;
      const typing = active?.matches('input,textarea,select,[contenteditable="true"]');
      const keyboard = window.visualViewport && window.visualViewport.height < window.innerHeight - 120;
      const overlay = [...document.querySelectorAll('dialog[open], [aria-modal="true"], localization-form .country-selector:not([hidden]), #Details-menu-drawer-container[open], cart-drawer.active, .csp-overlay.csp-open')].some(node => {
        const rect = node.getBoundingClientRect();
        return isVisible(node) && getComputedStyle(node).visibility !== 'hidden' && rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.left < innerWidth && rect.bottom > 0 && rect.top < innerHeight;
      });
      const hideSticky = !mobile.matches || !submit || submit.getBoundingClientRect().bottom > 0 || mainVisible || typing || keyboard || overlay;
      if (sticky.hidden !== hideSticky) sticky.hidden = hideSticky;
      if (!mobile.matches && dialog.open) dialog.close();
    };
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
    const visibility = new IntersectionObserver(entries => { mainVisible = entries[0].intersectionRatio >= .8; schedule(); }, { threshold: [0,.8,1] });
    if (submit) visibility.observe(submit);
    const label = () => {
      if (creamStyleGallery) {
        zoom.setAttribute('aria-label', panel.dataset.zoomLabel || 'Enlarge product image');
        if (!zoom.querySelector('svg')) zoom.innerHTML = '<svg viewBox="0 0 24 24" width="23" height="23" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><circle cx="10" cy="10" r="6.5"></circle><path d="m15 15 6 6M7 10h6M10 7v6"></path></svg>';
      } else zoom.textContent = (count?.textContent.trim() || '') + ' · ' + panel.dataset.zoomLabel;
      if (!mobile.matches) return;
      const active = thumbs.querySelector('[aria-current="true"]');
      if (active) {
        const rail = thumbs.getBoundingClientRect(), item = active.getBoundingClientRect();
        if (item.left < rail.left) thumbs.scrollBy({left: item.left - rail.left - 2, behavior: 'instant'});
        else if (item.right > rail.right) thumbs.scrollBy({left: item.right - rail.right + 2, behavior: 'instant'});
      }
    };
    const observer = new MutationObserver(label); if (count) observer.observe(count, { childList: true, characterData: true, subtree: true });
    let moved = false, origin = null;
    on(viewport, 'touchstart', event => { moved = false; origin = event.touches[0]?.clientX; }, {passive: true});
    on(viewport, 'touchmove', event => { if (origin != null && Math.abs(event.touches[0].clientX-origin)>12) moved = true; }, {passive: true});
    const enlarge = () => {
      if (!mobile.matches || moved) return;
      const index = [...thumbs.children].findIndex(node => node.getAttribute('aria-current') === 'true');
      const source = gallery.querySelectorAll('[data-ploy-gallery-slide] img')[Math.max(0,index)];
      if (!source) return;
      image.src = source.currentSrc || source.src; image.alt = source.alt;
      dialog.showModal(); update();
    };
    on(zoom, 'click', () => { moved = false; enlarge(); }); on(viewport, 'click', enlarge);
    on(thumbs, 'touchend', event => { if (mobile.matches) event.stopPropagation(); }, {passive: true});
    on(close, 'click', () => dialog.close()); on(dialog, 'close', schedule);
    on(panel.querySelector('[data-mobile-sticky-action]'), 'click', () => {
      if (form?.getAttribute('action')?.includes('/cart/add') && !form.querySelector('select')) form.requestSubmit(submit);
      else scrollToForm(panel);
    });
    const plans = [...panel.querySelectorAll('[data-mobile-plan]')];
    const terms = panel.querySelector('[data-mobile-plan-terms]');
    const quantity = panel.querySelector('.koppa-mobile-quantity input');
    const quantityButtons = [...panel.querySelectorAll('[data-mobile-quantity]')];
    const updatePurchase = () => {
      const chosen = plans.find(input => input.checked);
      if (terms) terms.hidden = !chosen?.value;
      if (chosen) {
        const price = panel.querySelector('[data-mobile-unit-price]');
        if (price?.firstChild) price.firstChild.textContent = chosen.dataset.money + ' ';
        const stickyPrice = panel.querySelector('.koppa-mobile-action-price');
        if (stickyPrice) stickyPrice.textContent = chosen.dataset.money;
      }
      if (quantity) {
        const value = Number(quantity.value), min = Number(quantity.min || 1), max = quantity.max ? Number(quantity.max) : Infinity;
        quantityButtons.forEach(button => button.disabled = Number(button.dataset.mobileQuantity) < 0 ? value <= min : value >= max);
      }
    };
    plans.forEach(input => on(input, 'change', updatePurchase));
    quantityButtons.forEach(button => on(button, 'click', () => {
      if (!quantity) return;
      if (!quantity.value || !Number.isFinite(Number(quantity.value))) quantity.value = quantity.min || '1';
      if (Number(button.dataset.mobileQuantity) > 0) quantity.stepUp(); else quantity.stepDown();
      quantity.dispatchEvent(new Event('change', {bubbles: true}));
    }));
    on(quantity, 'input', updatePurchase); on(quantity, 'change', updatePurchase);
    updatePurchase();
    panel.querySelectorAll('[data-mobile-detail-link]').forEach(link => on(link, 'click', event => {
      if (!mobile.matches) return;
      const detail = document.getElementById(link.hash.slice(1));
      if (!detail) return;
      event.preventDefault(); detail.open = true;
      detail.scrollIntoView({block: 'start', behavior: reducedMotion.matches ? 'instant' : 'smooth'});
      detail.querySelector('summary')?.focus({preventScroll: true});
    }));
    on(window, 'resize', schedule, {passive:true}); on(window, 'scroll', schedule, {passive:true}); on(window.visualViewport, 'resize', schedule, {passive:true}); on(document, 'focusin', schedule); on(document, 'focusout', schedule); on(mobile, 'change', schedule);
    const overlays = new MutationObserver(records => {
      if (records.some(record => record.attributeName !== 'class' || record.target.matches('#Details-menu-drawer-container,cart-drawer,.csp-overlay'))) schedule();
    });
    overlays.observe(document.body,{subtree:true,attributes:true,attributeFilter:['open','aria-modal','aria-hidden','aria-expanded','hidden','class']});
    instances.set(panel, () => { cleanup.forEach(fn => fn()); visibility.disconnect(); observer.disconnect(); overlays.disconnect(); cancelAnimationFrame(frame); dialog.remove(); zoom.remove(); delete gallery.dataset.mobileGalleryReady; });
    label(); update();
  }
  function scan() { document.querySelectorAll('[data-mobile-purchase]').forEach(mount); }
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => { for (const [panel,destroy] of instances) if (event.target.contains(panel)) { destroy(); instances.delete(panel); } });
  window.KoppaMobileHero = { scan }; scan();
})();
